import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  withStyles,
} from '@material-ui/core'
import styles from '../../styles'
import PaymentOptions from '../data/payment-options'

const PAYMENT_PROVIDER_MAP = {
  1: 'stripe',
  2: 'pabbly',
  3: 'lemon_squeeze',
}

const Provider = props => {
  const { handleChange, classes } = props

  const collectionSettings = useSelector(
    state => state.collection.collectionSettings,
  )

  const paymentProviderNumber = collectionSettings?.paymentProvider

  // State olarak paymentProvider'ı tanımla
  const [paymentProvider, setPaymentProvider] = useState('stripe')

  // Redux'tan gelen değer değiştiğinde state'i güncelle
  useEffect(() => {
    const provider = paymentProviderNumber
      ? PAYMENT_PROVIDER_MAP[paymentProviderNumber] || 'stripe'
      : 'stripe'
    setPaymentProvider(provider)
  }, [paymentProviderNumber])

  const handleLocalChange = event => {
    const newValue = event.target.value
    setPaymentProvider(newValue)
    handleChange && handleChange(event)
  }

  return (
    <FormControl variant="outlined" className={classes.formControlPayment}>
      <InputLabel id="payment-selection">Select Payment Processor</InputLabel>
      <Select
        labelId="payment-selection-label"
        id="payment-selection-select"
        value={paymentProvider || 'stripe'}
        onChange={handleLocalChange}
        size="small"
        label="Select Payment Processor"
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
          disablePortal: true,
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        }}
      >
        {PaymentOptions.map((option, index) => (
          <MenuItem value={option.value} key={index}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <img
                src={option.icon}
                alt={option.type}
                style={{ width: 24, marginRight: 4 }}
              />
              <Typography fontSize={'15px'} fontWeight={400}>
                {option.type}
              </Typography>
            </div>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default withStyles(styles)(Provider)
